module.exports = __webpack_public_path__ + "ba.no2.4b780876.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/aoyama/child_to_parent/ba.no2.jpg
// module id = Uvey
// module chunks = 0